export default __webpack_public_path__ + "static/media/movipack_feature3.30768561.svg";